import React from "react";
import { genInfoTranslations } from "./translation/genInfo";

export default function GenZInfoPanel({selectedLanguage, showIndiaStats, setShowIndiaStats,}) {
  const t = genInfoTranslations[selectedLanguage] || genInfoTranslations.en;

  return (
    <div
      className="
        mt-1
        rounded-2xl
        border border-purple-400/30
        bg-black/30
        backdrop-blur
        p-2
        space-y-2
      "
    >
      <div className="text-center">
        <div className="text-lg font-bold text-cyan-300">
          {t.title}
        </div>

        <div className="text-[10px] text-gray-300 mt-1">
          {t.subtitle}
        </div>
      </div>

      {/* GLOBAL TABLE */}
      <div className="overflow-x-auto flex justify-center flex-col">
        <div className="rounded-xl border border-cyan-500/30 p-3">
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-purple-500/30">
                <th className="text-left py-1 text-xs">{t.generation}</th>
                <th className="text-left py-1 text-xs">{t.birthYears}</th>
                <th className="text-left py-1 text-xs">{t.population}</th>
                <th className="text-left py-1 text-xs">{t.share}</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>⚡ Gen Alpha</td>
                <td>2013–2025</td>
                <td>2.0+ Billion</td>
                <td>24.4%</td>
              </tr>

              <tr>
                <td>🚀 Gen Z</td>
                <td>1997–2012</td>
                <td>1.8 Billion</td>
                <td>22.9%</td>
              </tr>

              <tr>
                <td>💼 Millennials</td>
                <td>1981–1996</td>
                <td>1.7 Billion</td>
                <td>21.2%</td>
              </tr>

              <tr>
                <td>📈 Gen X</td>
                <td>1965–1980</td>
                <td>1.3 Billion</td>
                <td>16.7%</td>
              </tr>

              <tr>
                <td>🏛️ Boomers+</td>
                <td>Pre-1964</td>
                <td>1.1 Billion</td>
                <td>15%</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* INDIA BUTTON */}
        <button
          onClick={() => setShowIndiaStats(!showIndiaStats)}
          className="
            mt-3
            w-full
            rounded-xl
            border border-orange-500/30
            bg-orange-500/10
            px-3
            py-2
            text-xs
            font-semibold
            hover:bg-orange-500/20
            transition-all
          "
        >
          {t.indiaSnapshot} {showIndiaStats ? "▲" : "▼"}
        </button>

        {/* INDIA SECTION */}
        {showIndiaStats && (
          <div className="mt-3 rounded-xl border border-orange-500/30 p-3">
            <div className="font-bold text-orange-300 mb-3">
              {t.indiaYouthAdvantage}
            </div>

            <table className="w-full text-xs">
              <thead>
                <tr className="border-b border-orange-500/30">
                  <th className="text-left py-2">{t.generation}</th>
                  <th className="text-left py-2">{t.birthYears}</th>
                  <th className="text-left py-2">{t.population}</th>
                  <th className="text-left py-2">{t.share}</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>⚡ Gen Alpha</td>
                  <td>2013–2025</td>
                  <td>~360M</td>
                  <td>24%</td>
                </tr>

                <tr>
                  <td>🚀 Gen Z</td>
                  <td>1997–2012</td>
                  <td>~377M</td>
                  <td>26%</td>
                </tr>

                <tr>
                  <td>💼 Millennials</td>
                  <td>1981–1996</td>
                  <td>~410M</td>
                  <td>28%</td>
                </tr>

                <tr>
                  <td>📈 Gen X</td>
                  <td>1965–1980</td>
                  <td>~210M</td>
                  <td>14%</td>
                </tr>

                <tr>
                  <td>🏛️ Boomers+</td>
                  <td>Pre-1964</td>
                  <td>~120M</td>
                  <td>8%</td>
                </tr>
              </tbody>
            </table>

            <div className="mt-4 text-xs space-y-2 text-gray-200">
              <div>{t.indiaPoint1}</div>
              <div>{t.indiaPoint2}</div>
              <div>{t.indiaPoint3}</div>
            </div>
          </div>
        )}
      </div>

      {/* INFO CARDS */}
      <div className="grid md:grid-cols-2 gap-3">
        <div className="rounded-xl border border-cyan-500/30 p-3">
          <div className="text-xs font-bold text-cyan-300 mb-2">
            {t.alphaTitle}
          </div>

          <div className="text-xs text-gray-300">
            {t.alphaDesc}
          </div>
        </div>

        <div className="rounded-xl border border-fuchsia-500/30 p-3">
          <div className="text-xs font-bold text-fuchsia-300 mb-2">
            {t.genzTitle}
          </div>

          <div className="text-xs text-gray-300">
            {t.genzDesc}
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className="rounded-xl bg-purple-900/40 p-4">
        <div className="text-xs font-bold text-purple-200 mb-2">
          {t.whyTitle}
        </div>

        <div className="text-xs text-purple-100 leading-relaxed">
          {t.whyDesc}
        </div>
      </div>
    </div>
  );
}